






export default {
  name: "TitleH2",
};
